import { Text, type TextProps } from '../atoms/Typography/Text';
import { useTranslation } from '../../i18n/useTranslation';
import { APP_VERSION } from '../../lib/appVersion';

export interface AppVersionProps extends Pick<TextProps, 'className' | 'size' | 'as'> {
  /** Version to show; defaults to the version of this build. */
  version?: string;
}

/**
 * "Version 1.4.0" (or "Version dev" outside production builds) — muted text,
 * used in the sidebar footer and in Settings → About ReefGuide.
 */
export function AppVersion({ version = APP_VERSION, className, size = 'xs', as = 'p' }: AppVersionProps) {
  const { t } = useTranslation();
  return (
    <Text as={as} size={size} color="muted" className={className}>
      {t('appVersion.label', { version })}
    </Text>
  );
}

export default AppVersion;
